import React, { useEffect, useState } from 'react'
import * as jwt from 'jsonwebtoken'
import Text from 'antd/lib/typography/Text'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Result } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { styled } from 'styled-components'
import PasswordForm from '../../../components/User/PasswordForm'
import { resetPasswordRequest } from '../../../redux/session/currentUser/actions'
import { UserPasswordCredentials } from '../../../types/user/User'
import { AppDispatch } from '../../../redux/store'

interface ResetPasswordProps {
  extra: string
}

const StyledReset = styled.div`
  max-width: 400px;
  padding: 0 16px;
  margin: 0 auto;
`

const ResetPassword: React.FC<ResetPasswordProps> = ({ extra }) => {
  const search = new URLSearchParams(useLocation().search)
  const { t } = useTranslation()
  const dispatch: AppDispatch = useDispatch()

  const navigate = useNavigate()
  const token = search.get('token')
  const [tokenError, setTokenError] = useState<jwt.VerifyErrors>()

  useEffect(() => {
    token &&
      process.env.REACT_APP_SECRET &&
      jwt.verify(token, process.env.REACT_APP_SECRET, err => {
        if (err) {
          setTokenError(err)
        }
      })
  }, [token])

  const handleSumit = (values: UserPasswordCredentials) => {
    token && dispatch(resetPasswordRequest(token, values))
    navigate('/user/login')
  }

  return tokenError ? (
    <Result status="403" title={t(`jwt:${tokenError.name}`)} subTitle={tokenError.message} extra={t(extra)} />
  ) : (
    <StyledReset>
      <Text>{t('usersPage:give-new-password')}</Text>
      <PasswordForm onSubmit={handleSumit} />
    </StyledReset>
  )
}

export default ResetPassword
